var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayCircleOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4,40.6 L39.2,28 L22.4,15.4 L22.4,40.6 Z M28,0 C12.544,0 0,12.544 0,28 C0,43.456 12.544,56 28,56 C43.456,56 56,43.456 56,28 C56,12.544 43.456,0 28,0 Z M28,50.4 C15.652,50.4 5.6,40.348 5.6,28 C5.6,15.652 15.652,5.6 28,5.6 C40.348,5.6 50.4,15.652 50.4,28 C50.4,40.348 40.348,50.4 28,50.4 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircleOutline);
export default __webpack_public_path__ + "static/media/play-circle-outline.31a2bf6cc8dbc67c9a89001b4fa8fd70.svg";
export { ForwardRef as ReactComponent };